import { z } from 'zod';
import type { BaseEntity } from './common';
import type { Worker } from './worker';

/**
 * WorkerHolidayPerYear - Ferie del lavoratore per anno
 * Rappresenta il bilancio delle ore di ferie di un lavoratore per un anno specifico
 * Corrisponde al modello backend WorkerHolidayPerYear
 */
export interface WorkerHolidayPerYear extends BaseEntity {
	/** ID del lavoratore */
	workerId: number;
	/** Lavoratore associato (navigation property, popolata con $expand=worker) */
	worker?: Worker;
	/** Anno di riferimento */
	year: number;
	/** Ore di bilancio rimanenti (decimal 18,4) */
	remainingBalanceHours: number;
	/** Ore di ferie annuali (decimal 18,4) */
	yearlyHolidayHours: number;
	/** Ore per l'anno successivo (decimal 18,4) */
	nextYearHours: number;
}

/**
 * Schema Zod per la validazione runtime dei WorkerHolidayPerYear
 */
export const WorkerHolidayPerYearSchema = z.object({
	id: z.number(),
	workerId: z.number(),
	year: z.number(),
	remainingBalanceHours: z.number(),
	yearlyHolidayHours: z.number(),
	nextYearHours: z.number(),
	// Campi audit da BaseEntity
	createdAt: z.string(),
	modifiedAt: z.string().optional(),
	createdBy: z.string(),
	modifiedBy: z.string().optional(),
	// Navigation property opzionale (non validata in runtime)
	worker: z.any().optional(),
});
